export default "__VITE_ASSET__BhEncc4z__"